import { createBrowserRouter } from "react-router-dom";
import publicRoutes from "./publicRoutes";
import privateRoutes from "./privateRoutes";
import AuthGuard from "./AuthGuard";
import DashboardLayout from "layout/Dashboard";
import Loadable from "../components/Loadable";
import { lazy } from "react";

const NotFound404Page = Loadable(lazy(() => import("../components/Page404")));

const router = createBrowserRouter([
	// 🌐 Public routes
	...publicRoutes.map((route) => ({
		path: route.path,
		element: route.element,
	})),

	// 🔐 Protected routes with DashboardLayout
	{
		path: "/",
		element: (
			<AuthGuard>
				<DashboardLayout />
			</AuthGuard>
		),
		children: [
			// Spread all private routes
			...privateRoutes.map((route) => ({
				path: route.path, // e.g., "/dashboard", "assistant/add", etc.
				element: route.element,
			})),

			// Catch-all for unknown routes INSIDE the protected area
			{
				path: "*",
				element: <NotFound404Page />,
			},
		],
	},
]);

export default router;
